import React from "react";
import Grid from "@material-ui/core/Grid";
import Clock from "../assets/clock-icon.png";
import socketIOClient from "socket.io-client";
import odometer from "../assets/odometer.png";
import odometer1 from "../assets/odometer1.png";
import productTemp from "../assets/productTemp.png";
import ambientTemp from "../assets/ambientTemp.png";
import action2 from "../assets/action2.png";
import CountUp from "react-countup";
import arrowUp from "../assets/arrow-up.png";
import arrowDown from "../assets/arrow-down.png";
import axios from "axios";

function ProductTemp() {
  const [rotate, setRotate] = React.useState(0);

  const [grillPosition, setPosition] = React.useState(0);

  const [firecooker, setFirecooker] = React.useState({
    actualTemperature: 0,
    timeElapsed: "00:00:00",
    actualGrillTemperature: 0,
    powerGrill: [],
    _id: null,
  });

  React.useEffect(() => {
    const socket = socketIOClient(process.env.REACT_APP_API_ENDPOINT);
    socket.on("connect", () => {
      console.log("connected");
    });
    socket.on("disconnect", () => {
      console.log("disconnected");
    });
    socket.on("firecooker", (data) => {
      console.log(data);
      setFirecooker({
        actualTemperature: data.actualTemperature,
        timeElapsed: data.timeElapsed,
        actualGrillTemperature: data.actualGrillTemperature,
        gridPosition: data.gridPosition,
        powerGrill: data.powerGrill,
        _id: data._id,
      });
      setRotate(data.actualTemperature);
    });

    return () => {
      socket.disconnect();
    };
  }, []);


  const sendGrillPosition = () => {
    // Send position to server post
    // destructure firecooker useState
    const { timeElapsed, actualTemperature, actualGrillTemperature } =
    firecooker;
  firecooker.powerGrill.map((item, index) => {
    if (item.active === true) {
      item.active = false;
    }
    if (index === grillPosition) {
      item.active = true;
    }
  });
  axios
    .put(
      process.env.REACT_APP_API_ENDPOINT +
        "/api/FireData/" +
        firecooker._id,
      {
        timeElapsed,
        actualTemperature,
        actualGrillTemperature,
        powerGrill: firecooker.powerGrill,
        gridPosition: grillPosition,
      }
    )
    .then((res) => {
      console.log(res);
    });

  };

  return (
    <>
      <Grid
        item
        xs={12}
        sm={4}
        md={2}
        style={{
          border: "2px solid #737374",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          onClick={() => {
            if (
              firecooker.powerGrill.length - 1 >= grillPosition &&
              grillPosition > 0
            ) {
              setPosition(grillPosition - 1);
            }
          }}
          style={{
            margin: 70,
          }}
          width="70px"
          src={arrowUp}
          alt=""
        />

        {firecooker.powerGrill
          // .sort((a, b) => b.id - a.id)
          .map((item, index) => {
            return item.active === true ? (
              <div
                key={index}
                style={{
                  border: "2px solid #737374",
                  width: "200px",
                  height: "15px",
                  borderRadius: 20,
                  marginTop: 8,
                  backgroundColor: "#737374",
                }}
              ></div>
            ) : index === grillPosition ? (
              <div
                key={index}
                style={{
                  border: "2px solid #737374",
                  width: "200px",
                  height: "15px",
                  borderRadius: 20,
                  marginTop: 8,
                  backgroundColor: "green",
                }}
              ></div>
            ) : (
              <div
                key={index}
                style={{
                  border: "2px solid #737374",
                  width: "200px",
                  height: "15px",
                  borderRadius: 20,
                  marginTop: 8,
                }}
              ></div>
            );
          })}

        <img
          onClick={() => {
            if (firecooker.powerGrill.length - 1 > grillPosition) {
              setPosition(grillPosition + 1);
            }
          }}
          style={{
            margin: 70,
          }}
          width="70px"
          src={arrowDown}
          alt=""
        />

        {/* button */}
        <button
          onClick={() => {
            sendGrillPosition();
          }}
          style={{
            
            backgroundColor: "#737374",
            border: "none",
            borderRadius: "20px",
            color: "white",
            padding: "10px 20px",
            textAlign: "center",
            textDecoration: "none",
            display: "inline-block",
            fontSize: "16px",
            cursor: "pointer",
            marginBottom: "20px",

          }}
        >
          Send new grill position ✔️
        </button>

      </Grid>
      <Grid
        item
        xs={12}
        sm={4}
        md={8}
        style={{
          border: "2px solid #737374",
        }}
      >
        <Grid container>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img src={Clock} style={{ marginRight: 90 }} width={50} alt="" />
            <h3 className="title">{firecooker.timeElapsed}</h3>

            <p style={{ paddingTop: 10, fontSize: 25, marginLeft: 10 }}>
              (Time elapsed)
            </p>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: 200,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={productTemp}
                style={{ marginRight: 90 }}
                width={130}
                alt=""
              />
              <h3 style={{ fontSize: 100 }} className="title">
                <CountUp
                  start={0}
                  end={firecooker.actualTemperature}
                  duration={1}
                />
                ºF
              </h3>
              <p style={{ paddingBottom: 30, marginLeft: 10, fontSize: 20 }}>
                Actual Product Temp
              </p>
            </div>
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: 200,
              marginTop: 20,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                borderTop: "2px solid",
                height: 200,
                width: "80%",
                marginTop: 10,
              }}
            >
              <img
                src={ambientTemp}
                style={{ marginRight: 90 }}
                width={90}
                height={120}
                alt=""
              />
              <h3 style={{ fontSize: 100 }} className="title">
                <CountUp
                  start={0}
                  end={firecooker.actualGrillTemperature}
                  duration={1}
                />
              </h3>
              <p style={{ paddingBottom: 40, fontSize: 45 }}>ºF</p>
              <p style={{ fontSize: 35, marginLeft: 20 }}>(Low)</p>
              <p style={{ paddingTop: 110, fontSize: 35 }}>Actual Grill Temp</p>
            </div>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        sm={4}
        md={2}
        style={{
          border: "2px solid #737374",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img src={action2} width={70} alt="" />
        <p style={{ fontSize: 35, textAlign: "center" }}>
          Product Set Temperature
        </p>
        <div style={{ position: "relative" }}>
          <img
            style={{ top: -36, right: -36, position: "absolute" }}
            width={220}
            src={odometer}
            alt=""
          />
          <img
            style={{ transform: `rotate(${rotate}deg)` }}
            width={150}
            src={odometer1}
            alt=""
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <p style={{ fontSize: 20, textAlign: "center", marginRight: 50 }}>
            Min.
          </p>
          <p style={{ fontSize: 20, textAlign: "center", marginLeft: 50 }}>
            Max.
          </p>
        </div>
        <div>
          <p
            style={{
              fontSize: 35,
              textAlign: "center",
              borderBottom: "2px solid",
              width: 130,
            }}
          >
            <CountUp
              start={0}
              end={firecooker.actualTemperature}
              duration={1}
            />
            °F
          </p>
          <p
            style={{
              fontSize: 25,
              textAlign: "center",
              width: 130,
              marginTop: -10,
            }}
          >
            Med-Well
          </p>
        </div>
      </Grid>
    </>
  );
}

export default ProductTemp;
